<input
  (blur)="propagateTouch(searchInput); onBlur()"
  (keydown.tab)="onTab($event)"
  (selectItem)="onSelected($event)"
  [(ngModel)]="model"
  [autofocus]="hasfocus"
  [inputFormatter]="inputFormatter"
  [ngbTypeahead]="search"
  [resultFormatter]="resultFormatter"
  #searchInput
  class="typeahead-input"
  type="search" />
@if (showNoResultText) {
  <div class="dropdown-menu show dropdown-message">
    <button (click)="onClear()" class="dropdown-item">{{ "search.noResults" | translate }}</button>
  </div>
}
